import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const styles = theme => ({
});

class ListManager extends Component {
    state = {
      text:''
    };

    delete(item, event){
      let newList = this.props.list.filter(i => i !== item);
      this.props.cbListUpdate(newList);
    }
    
    add(e){
      if (this.state.text.trim() !== ''){
        let newList = [...this.props.list, this.state.text.trim()];
        this.props.cbListUpdate(newList);
      }
    }

    handleChange = field => event => {
      this.setState({ [field]: event.target.value });
    };

    render(){
    
    return(
      <div>
        <TextField variant="outlined" style={{width:'98%', margin:10}} 
          value={this.state.text} 
          onChange={this.handleChange('text')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label='Add'
                  onClick={this.add.bind(this)}
                >
                  <PlaylistAdd />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {/* <List key={`list${timestamp}`} */}
        <List className={this.props.className || ''}
        //subheader={<ListSubheader>Terpene:</ListSubheader>}
        >
          { this.props.list ? 
            this.props.list.map( t => 
            <ListItem key={t}>
              <ListItemText primary={t}/>
              <ListItemSecondaryAction>
                <IconButton aria-label="Delete" onClick={this.delete.bind(this, t)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            )
            :''
          }
        </List>
      </div>
    );
  }
}

export default withStyles(styles)(ListManager);